import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Image, List, Message } from 'semantic-ui-react';

import Create from './Create';
import { Content } from '../../components';
import { API } from '../../services';

class Roles extends Component {
  /**
   * @property {Object}
   */
  state = {
    creating: false,
    loading: true,
    message: {},
    roles: [],
  };

  /**
   * @param {Readonly<Object>} props
   * @constructs Roles
   */
  constructor(props) {
    super(props);
    this.handleCreateClose = this.createCloseListener.bind(this);
    this.handleDismissErrorMessage = this.messageDismissedListener('error').bind(this);
    this.pageActions = [
      {
        handler: this.createOpenListener.bind(this),
        label: props.t('button.create'),
      },
    ];
  }

  /**
   * @return {void}
   */
  componentDidMount() {
    API
      .get('/api/v1/roles')
      .then((response) => {
        this.setState({
          roles: response.data,
        });
      })
      .catch((reason) => {
        this.setState({
          message: {
            ...this.state.message,
            error: 'retrieve',
          },
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  /**
   * @param  {React.MouseEvent} event 
   * 
   * @return {void}
   */
  createCloseListener(event) {
    this.setState({ creating: false });
  }

  /**
   * @param  {React.MouseEvent} event 
   * 
   * @return {void}
   */
  createOpenListener(event) {
    this.setState({ creating: true });
  }

  /**
   * @param  {String} name
   *
   * @return {function(React.MouseEvent)}
   */
  messageDismissedListener(name) {
    return (event) => {
      const { message } = this.state;
      message[name] = null;
      this.setState({ message });
    };
  }

  render() {
    const { match: { url }, t } = this.props;
    return (
      <Content actions={this.pageActions} loading={this.state.loading} title={t('title.index')}>
        {
          this.state.message.error
          && <Message
            content={t(`message.error.${this.state.message.error}.content`)}
            error
            icon='exclamation'
            header={t(`message.error.${this.state.message.error}.title`)}
            onDismiss={this.handleDismissErrorMessage}
          />
        }
        <List divided verticalAlign='middle'>
          {
            this.state.roles.map(
              (role, index) => (
                <List.Item key={`role${index}`}>
                  <List.Content floated='right'>
                    <Button as={Link} to={`${url}/${role.id}`}>{t('button.edit')}</Button>
                  </List.Content>
                  <Image avatar src='/favicon.ico' />
                  <List.Content>
                    <List.Header>{role.name}</List.Header>
                  </List.Content>
                </List.Item>
              )
            )
          }
        </List>
        <Create onClose={this.handleCreateClose} open={this.state.creating} />
      </Content>
    );
  }
}

export default withTranslation('roles')(Roles);
